import { render } from "./RatingComp.vue?vue&type=template&id=1661220a&scoped=true"
import script from "./RatingComp.vue?vue&type=script&lang=js"
export * from "./RatingComp.vue?vue&type=script&lang=js"

import "./RatingComp.vue?vue&type=style&index=0&id=1661220a&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1661220a"]])

export default __exports__